var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 10.5V7.375H3.625V10.5M9.25 10.5H1.75C1.05964 10.5 0.5 9.94037 0.5 9.25V1.75C0.5 1.05964 1.05964 0.5 1.75 0.5H6.85725C7.18875 0.5 7.50669 0.631694 7.74113 0.866119L10.1339 3.25888C10.3683 3.49331 10.5 3.81124 10.5 4.14277V9.25C10.5 9.94037 9.94037 10.5 9.25 10.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.94eb35faca474364344378ab807e57a9.svg";
export { ForwardRef as ReactComponent };